import { IDeleteProvisaoRecursoUseCase } from "../../../presentation/useCases/delete/delete_provisao_recurso_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteProvisaoRecursoUseCase


export class DeleteProvisaoRecursoUseCase implements IDeleteProvisaoRecursoUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteProvisaoRecurso( IdProvisaoRecurso: number): Promise<void> {
    
    await this.repository.deleteProvisaoRecurso( IdProvisaoRecurso );
  }
}
